// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'user',
    path: '/dashboard/user',
    icon: icon('ic_user'),
  },
  {
    title: 'Home',
    path: '/dashboard/home',
    icon: icon('ic_home'),
  },
  {
    title: 'About Us',
    path: '/dashboard/aboutus',
    icon: icon('ic_about'),
  },
  {
    title: 'Solutions',
    path: '/dashboard/solutions',
    icon: icon('ic_solutions'),
  },
  {
    title: 'Services',
    path: '/dashboard/services',
    icon: icon('ic_services'),
  },
  {
    title: 'Contact Us',
    path: '/dashboard/contactus',
    icon: icon('ic_contact'),
  },
  {
    title: 'Partners',
    path: '/dashboard/partners',
    icon: icon('ic_partners'),
  },
  {
    title: 'event',
    path: '/dashboard/event',
    icon: icon('ic_event'),
  },
  {
    title: 'Announcement',
    path: '/dashboard/announcement',
    icon: icon('ic_anouncement'),
  },
  {
    title: 'Privacy Policy',
    path: '/dashboard/privacypolicy',
    icon: icon('ic_privacy'),
  },
  {
    title: 'Code of Conduct',
    path: '/dashboard/codeofconduct',
    icon: icon('ic_law'),
  },
];

export default navConfig;
